import type { ISessionData } from './types'

export const generateSessionId = (): string =>
  `session_${Math.random().toString(36).substring(2, 15)}`

export const getCurrentTimestamp = (): string => new Date().toISOString()

export const isPageRefresh = (): boolean => {
  if (performance.navigation) {
    return performance.navigation.type === performance.navigation.TYPE_RELOAD
  }
  const [navigationEntry] = performance.getEntriesByType(
    'navigation',
  ) as PerformanceNavigationTiming[]
  return navigationEntry?.type === 'reload'
}

export const createSessionData = (sessionId: string): ISessionData => ({
  sessionId,
  pageViews: 1,
  refreshCount: 0,
  firstLoadTimestamp: getCurrentTimestamp(),
  lastActivity: getCurrentTimestamp(),
})

export const updateSessionData = (
  existingData: ISessionData,
  isRefresh: boolean,
): ISessionData => ({
  ...existingData,
  pageViews: existingData.pageViews + 1,
  refreshCount: isRefresh
    ? existingData.refreshCount + 1
    : existingData.refreshCount,
  lastActivity: getCurrentTimestamp(),
})

export const isSessionValid = (sessionData: ISessionData | null): boolean => {
  if (!sessionData) return false
  const lastActivity = new Date(sessionData.lastActivity).getTime()
  const now = new Date().getTime()
  return now - lastActivity < 30 * 60 * 1000
}

export const persistSessionData = (sessionData: ISessionData): ISessionData => {
  localStorage.setItem('sessionData', JSON.stringify(sessionData))
  return sessionData
}

export const getOrCreateSessionData = (): ISessionData => {
  const storedSession = localStorage.getItem('sessionData')
  const parsedSession = storedSession ? JSON.parse(storedSession) : null

  if (parsedSession && isSessionValid(parsedSession)) {
    return updateSessionData(parsedSession, isPageRefresh())
  }

  return createSessionData(generateSessionId())
}
